import {NgModule} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { SliderModule } from 'primeng/slider';
import { RatingModule } from 'primeng/rating';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ChartModule } from 'primeng/chart';
import { MenuModule } from 'primeng/menu';
import { StyleClassModule } from 'primeng/styleclass';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DividerModule } from 'primeng/divider';

import {TreeSelectModule} from 'primeng/treeselect';

import { FileUploadModule } from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';

import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { ChipModule } from 'primeng/chip';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from "primeng/calendar";
import { ChipsModule } from "primeng/chips";
import { CascadeSelectModule } from "primeng/cascadeselect";
import { AutoCompleteModule } from "primeng/autocomplete";
import { InputMaskModule } from "primeng/inputmask";
import {ListboxModule} from 'primeng/listbox';
import {DataViewModule} from 'primeng/dataview';
import {PaginatorModule} from 'primeng/paginator';
import {EditorModule} from 'primeng/editor';
import { ImageModule } from 'primeng/image';
import {GalleriaModule} from 'primeng/galleria';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';

@NgModule({
  exports: [
    TableModule,
		ButtonModule,
		InputTextModule,
    ImageModule,
    GalleriaModule,
    RatingModule,
		SliderModule,
		RippleModule,
		MultiSelectModule,
		DropdownModule,
		ProgressBarModule,
		ToastModule,
    PaginatorModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    ChartModule,
    MenuModule,
    StyleClassModule,
    PanelMenuModule,
    DividerModule,
    TimelineModule,
    CardModule,
    ListboxModule,
    ChipModule,
    CheckboxModule,
    EditorModule,
    PasswordModule,
    TreeSelectModule,

    FileUploadModule,
    ToolbarModule,
    InputTextareaModule,
    InputNumberModule,
    DialogModule,
    DataViewModule,

		AutoCompleteModule,
		CalendarModule,
		ChipsModule,
		InputMaskModule,
		CascadeSelectModule,
    ProgressSpinnerModule,
    SelectButtonModule
	
  ]
})
export class PrimeNgModule {}
